import { createRouter } from "@tanstack/react-router";
import { Route } from "./routes/__root";
import { indexRoute } from "./routes/index";
import { loginRoute } from "./routes/login";
import { generationRoute } from "./routes/generation";
import { moeRedirectRoute } from "./routes/moe-redirect";
import { naniClubRedirectRoute } from "./routes/nani-club-redirect";

const routeTree = Route.addChildren([
  indexRoute,
  loginRoute,
  generationRoute,
  moeRedirectRoute,
  naniClubRedirectRoute,
]);

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
